import { useMemo } from "react";

// Components
import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";

// Assets
import { ReactComponent as XIcon } from "assets/cross.svg";
import IHourGlass from "assets/i-hourglass.png";
import ISuccess from "assets/i-success-terhubung.png";
import IFailedConnected from "assets/i-gagal-hubungkan-akun.png";

const ModalHasilHubungkanAkun = ({
  onSubmit,
  onClose,
  onBack,
  isOpen,
  akun,
  isGagal,
  ...props
}) => {
  const isBeliRumah = akun.name === "BeliRumah.co";

  const title = useMemo(() => {
    let res = (
      <p className="text-[17px] font-inter-semibold">
        Menghubungkan akun ke <span className="capitalize">{akun.name}</span>
      </p>
    );

    if (isGagal && isBeliRumah) {
      res = (
        <p className="text-[17px] font-inter-semibold">
          Gagal terhubung ke BeliRumah.co
        </p>
      );
    }

    if (isBeliRumah) {
      res = (
        <p className="text-[17px] font-inter-semibold">
          Berhasil terhubung ke BeliRumah.co
        </p>
      );
    }

    return res;
  }, [isBeliRumah, isGagal, akun]);

  const info = useMemo(() => {
    let res = (
      <p className="text-[13px] font-inter text-[#252526]">
        Email Anda sudah dikirim ke {akun.name} untuk proses penyambungan akun.
        Tunggu sekitar 1x24 jam hingga akunmu terhubung. Setelah tersambung,
        Anda bisa langsung promosi listing ke {akun.name}.
      </p>
    );

    if (isGagal && isBeliRumah) {
      res = (
        <p className="text-[13px] font-inter text-[#252526]">
          Marketing terkait kini dapat mempromosikan listing di BeliRumah.co
          melalui ONE21.
        </p>
      );
    }

    if (isBeliRumah) {
      res = (
        <p className="text-[13px] font-inter text-[#252526]">
          Marketing terkait kini dapat mempromosikan listing di BeliRumah.co
          melalui ONE21.
        </p>
      );
    }

    return res;
  }, [isBeliRumah, isGagal, akun]);

  const Icon = useMemo(() => {
    let res = IHourGlass;

    if (isGagal && isBeliRumah) {
      res = IFailedConnected
    }

    if (isBeliRumah) {
      res = ISuccess;
    }

    return res;
  }, [isBeliRumah, isGagal]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} {...props}>
      <div
        className="w-[426px] z-[42] bg-white rounded-md border-[0.5px] border-solid border-[#ECECEC] 
        shadow-[0px_1px_3px_0px_rgba(16,16,16,0.10),_0px_1px_2px_0px_rgba(16,16,16,0.06)]"
      >
        <div className="flex justify-between px-4 py-2 border-b border-solid border-[#D8D8D9]">
          {title}
          <XIcon onClick={onClose} />
        </div>

        <div className="py-2 px-4 border-b border-dashed border-[#D8D8D9]">
          <img
            className="block mx-auto w-[80px] aspect-square object-contain mb-2"
            src={Icon}
            alt={"Hour Glass"}
          />
          {info}
        </div>

        <div className="flex gap-[12px] justify-end px-4 py-2 border-t border-solid border-[#D8D8D9]">
          <Button
            size="s"
            type="secondary"
            text="Kembali: Akun Terhubung"
            onClick={onBack}
          />
          <Button size="s" text="Tutup" onClick={onClose} />
        </div>
      </div>
    </Modal>
  );
};

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null;
  return <ModalHasilHubungkanAkun isOpen={isOpen} {...props} />;
};

export default Wrapper;
